import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { Config, DoubleText } from "@components/table";
import { AdminOrder } from "@features/admin/order/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatUsdt, formatRubles } from "@helpers/format";
import styles from "./deal.module.scss";
import { EllipsisText } from "@components/ellipsis-text";

const adminDealConfig: Config<AdminOrder> = [
  {
    label: "ID сделки",
    source: "id",
    renderComponent: (data) => (
      <EllipsisText text={data} copy startLength={10} />
    ),
  },
  {
    label: "Invid",
    source: "invid",
    renderComponent: (item) => <EllipsisText text={item} copy />,
  },
  {
    label: "Статус",
    source: "status",
  },
  {
    label: "Дата Время",
    source: "created_at_unix",
    renderComponent: (data) => (
      <>
        {formatTime(new Date(data * 1000))} {formatDate(new Date(data * 1000))}
      </>
    ),
  },
  {
    label: "Курс",
    source: "exchange_rate",
  },
  {
    label: "Сумма заявки",
    source: "order_start_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.order_start_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Сумма мерча",
    source: "merchant_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.merchant_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Итоговая сумма",
    source: "order_final_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.order_final_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Валюта",
    source: "currency",
  },
  {
    label: "Метод",
    source: "method",
  },
  {
    label: "Реквизит",
    source: "requisite",
  },
  {
    label: "Наш доход",
    source: "our_ern_usdt",
    renderComponent: (data) => formatUsdt(data),
  },
  {
    label: "Id мерч",
    source: "merchant_id",
    renderComponent: (data) => (
      <EllipsisText text={data} copy startLength={10} />
    ),
  },
  {
    label: "Email мерч",
    source: "merchant_login",
  },
  {
    label: "Доход мерча",
    source: "merchant_ern_usdt",
    renderComponent: (data) => formatUsdt(data),
  },
  {
    label: "Id трейдер",
    source: "trader_id",
    renderComponent: (data) => (
      <EllipsisText text={data} copy startLength={10} />
    ),
  },
  {
    label: "Email трейдер",
    source: "trader_email",
  },
  {
    label: "Доход трейдера",
    source: "trader_ern_usdt",
    renderComponent: (data) => formatUsdt(data),
  },
];

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  data: AdminOrder;
};

export const AdminDealModal = ({ hideModal, isModalOpen, data }: Props) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title={""}
      className={styles.modal}
    >
      <RowTable config={adminDealConfig} data={data} />
    </Modal>
  );
};
